import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfComponentstypes } from '@/modules/Configuracion/interfaces'
export class ComponentTypeServicios extends BaseService<IConfComponentstypes> {
  constructor () {
    super({
      baseUrl: 'system/components-types/'
    })
  }
}
